import { useState } from 'react'

import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'

/**
 * 자유 텍스트 태그 목록 편집 — 대여 장비(`rentalEquipments`) 전용(설계 §2-1(d)).
 *
 * 개수·항목 길이 상한은 제출 시 `validateVenueProfileForm` 이 검사한다(서버 검증표와 동일 규칙).
 * 이 컴포넌트는 입력 편의(추가·삭제)만 담당하고 상한을 스스로 강제하지 않는다.
 */
export function VenueTagListEditor({
  label,
  items,
  onChange,
  placeholder = '예: 라켓',
}: {
  label: string
  items: string[]
  onChange: (items: string[]) => void
  placeholder?: string
}) {
  const [draft, setDraft] = useState('')

  function addDraft() {
    const trimmed = draft.trim()
    if (trimmed.length === 0) return
    onChange([...items, trimmed])
    setDraft('')
  }

  function remove(index: number) {
    onChange(items.filter((_, itemIndex) => itemIndex !== index))
  }

  return (
    <div>
      <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>
      <div className="flex gap-2">
        <Input
          value={draft}
          placeholder={placeholder}
          onChange={(event) => {
            setDraft(event.target.value)
          }}
          onKeyDown={(event) => {
            if (event.key !== 'Enter') return
            event.preventDefault()
            addDraft()
          }}
        />
        <Button type="button" variant="secondary" onClick={addDraft}>
          추가
        </Button>
      </div>
      {items.length > 0 ? (
        <ul className="mt-2 flex flex-wrap gap-2">
          {items.map((item, index) => (
            <li
              key={`${item}-${index}`}
              className="flex items-center gap-1.5 rounded-full bg-slateish-100 py-1 pl-3 pr-1.5 text-sm text-ink-700"
            >
              {item}
              <button
                type="button"
                aria-label={`${item} 삭제`}
                onClick={() => {
                  remove(index)
                }}
                className="rounded-full px-1.5 text-slateish-500 hover:bg-slateish-200 hover:text-ink-700"
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
